import { render, staticRenderFns } from "./turn.vue?vue&type=template&id=6917a943&scoped=true"
import script from "./turn.vue?vue&type=script&lang=js"
export * from "./turn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6917a943",
  null
  
)

export default component.exports